import { React } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, CheckboxField, RadioGroupField, Radio, Flex, Text, TextField, View } from '@aws-amplify/ui-react';
import { handleInteger, handleIntegerBlur, typedReturnValue, handleSimpleDate, handleSimpleDateBlur } from "../anamnese_lib/validateInteger";
import YesNo from "../anamnese_lib/YesNo";
import { DatumToString } from "../../lib/DatumToString";
import StringToDate from "../../lib/StringToDate";
import DatePicker from "react-date-picker";

const SozialAnamnese = (props) => {
    const daten = useSelector(state => state.anamnese.Daten);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        // console.log(e.target)
        const key = e.target.name;
        const val = key === 'KINDER_UNTERHALT_WEGEN' ? Array.from(e.target.selectedOptions, option => option.value) :
            typedReturnValue(key, e.target.value);
        // console.log(key, val)
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleArray = (e) => {
        // KINDER_UNTERHALT_WEGEN_
        const name = e.target.name;
        // console.log(e.target, daten.KINDER_UNTERHALT_WEGEN)
        const key = 'KINDER_UNTERHALT_WEGEN';
        const possible_value = name.slice(-1);
        const val = e.target.value === 'on' ?
            [...daten.KINDER_UNTERHALT_WEGEN, possible_value] :
            daten.KINDER_UNTERHALT_WEGEN.filter(item => item !== possible_value);
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleCheck = (e) => {
        const key = e.target.name;
        const val = e.target.value === 'on' ? 1 : 0;
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleDate = (e) => {
        // console.log(e);
        const key = e.currentTarget.name;
        const val = DatumToString(e.currentTarget.value);
        const validated = val === 'NaN.NaN.NaN' ? '' : val;
        dispatch({ type: 'anamnese/Modify', payload: { [key]: validated } });
        props.handleChange({ target: { name: key, value: validated } });
    }

    /*
                            <SelectField
                            value={daten.KINDER_UNTERHALT_WEGEN}
                            onChange={handleChange}
                            label="wegen:"
                            name="KINDER_UNTERHALT_WEGEN"
                            direction="row"
                            alignItems="center"
                            multiple={true}
                            disabled={props.readOnly}
                        >
                            <option value="1">Schüler/in</option>
                            <option value="2">Ausbildung</option>
                            <option value="3">Studium</option>
                            <option value="4">Pflegefall</option>
                        </SelectField>
*/

    return (

        <Flex
            width="100%"
            direction="column"
            gap="0.1rem"
        >
            <h4>2.1 Sozialanamnese</h4>
            <h5>Familienstand</h5>
            <RadioGroupField
                value={daten.FAMSTAND}
                onChange={handleChange}
                descriptiveText=""
                name="FAMSTAND"
                direction="row">
                {['ledig', 'verheiratet', 'geschieden'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.FAMSTAND !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.FAMSTAND}
                onChange={handleChange}
                descriptiveText=""
                name="FAMSTAND"
                direction="row">
                {['getrennt lebend', 'verwitwet', 'Lebenspartner/in'].map((item, i) => <Radio key={`RG_${i + 3}`} value={i + 3} disabled={daten.FAMSTAND !== (i + 3) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <p></p>
            <h5>Im Haushalt lebende Personen</h5>
            <RadioGroupField
                value={daten.HAUSH}
                onChange={handleChange}
                descriptiveText=""
                name="HAUSH"
                direction="row">
                {['allein lebend', 'Partner/in'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.HAUSH !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <View>Kinder:</View> <YesNo name="HAUSH_K" value={daten.HAUSH_K} onChange={handleChange} readOnly={props.readOnly} />
            <Flex
                direction="row"
                gap={'1.5rem'}
                alignItems="center"
            >
                {daten.HAUSH_K === 1 &&
                    <>
                        <TextField
                            name="KINDER"
                            defaultValue={daten.KINDER}
                            width="10%"
                            hasError={props.hasError.KINDER}
                            errorMessage="Der Wert muß zwischen 1 und 20 liegen."
                            onChange={(e) => handleInteger(e, handleChange, 1, 20, props.hasError, props.setHasError)}
                            onBlur={(e) => handleIntegerBlur(e, 1, 20, props.hasError, props.setHasError)}
                            direction="row"
                            readOnly={props.readOnly}
                        />
                        <TextField
                            name="KINDER_ALTER"
                            label="Alter:"
                            placeholder="7, 10, 14"
                            defaultValue={daten.KINDER_ALTER}
                            width="60%"
                            onChange={handleChange}
                            direction="row"
                            alignItems="center"
                            maxLength={40}
                            readOnly={props.readOnly}
                        />
                    </>
                }
            </Flex>
            <p></p>
            {daten.HAUSH_K === 1 &&
                <Flex
                    width="100%"
                    direction="column"
                    gap="0.1rem"
                >
                    <Flex
                        direction="row"
                        gap={'1.5rem'}
                        alignItems="center"
                    >
                        <Text>davon noch zu unterhalten:</Text>
                        <TextField
                            name="KINDER_UNTERHALT"
                            defaultValue={daten.KINDER_UNTERHALT}
                            width="10%"
                            label=""
                            hasError={props.hasError.KINDER_UNTERHALT}
                            errorMessage="Der Wert muß zwischen 0 und 20 liegen."
                            onChange={(e) => handleInteger(e, handleChange, 0, 20, props.hasError, props.setHasError)}
                            onBlur={(e) => handleIntegerBlur(e, 0, 20, props.hasError, props.setHasError)}
                            direction="row"
                            readOnly={props.readOnly}
                        />
                    </Flex>
                    <p></p>
                    <Flex
                        direction="row"
                        gap={'1.5rem'}
                        alignItems="center"
                    >
                        <Text>wegen:</Text>
                        <CheckboxField
                            name="KINDER_UNTERHALT_WEGEN_1"
                            value={(daten.KINDER_UNTERHALT_WEGEN).includes('1') ? "off" : "on"}
                            checked={(daten.KINDER_UNTERHALT_WEGEN).includes('1')}
                            onChange={handleArray}
                            label="Schüler/in"
                            disabled={props.readOnly}
                        />
                        <CheckboxField
                            name="KINDER_UNTERHALT_WEGEN_2"
                            value={(daten.KINDER_UNTERHALT_WEGEN).includes('2') ? "off" : "on"}
                            checked={(daten.KINDER_UNTERHALT_WEGEN).includes('2')}
                            onChange={handleArray}
                            label="Ausbildung"
                            disabled={props.readOnly}
                        />
                    </Flex>
                    <Flex
                        direction="row"
                        gap={'1.5rem'}
                        alignItems="center"
                        style={{ marginLeft: '4.5rem' }}
                    >
                        <CheckboxField
                            name="KINDER_UNTERHALT_WEGEN_3"
                            value={(daten.KINDER_UNTERHALT_WEGEN).includes('3') ? "off" : "on"}
                            checked={(daten.KINDER_UNTERHALT_WEGEN).includes('3')}
                            onChange={handleArray}
                            label="Studium"
                            disabled={props.readOnly}
                        />
                        <CheckboxField
                            name="KINDER_UNTERHALT_WEGEN_4"
                            value={(daten.KINDER_UNTERHALT_WEGEN).includes('4') ? "off" : "on"}
                            checked={(daten.KINDER_UNTERHALT_WEGEN).includes('4')}
                            onChange={handleArray}
                            label="Pflegefall"
                            disabled={props.readOnly}
                        />
                    </Flex>
                    <p></p>
                    <Flex 
                        width="100%"
                        direction="row"
                        gap="1rem"
                        alignItems="center" 
                    >
                        <Text 
                            minWidth="70px"
                            >sonstiges:</Text>
                        <TextField
                            name="KINDER_UNTERHALT_SONST"
                            defaultValue={daten.KINDER_UNTERHALT_SONST}
                            width="100%"
                            onChange={handleChange}
                            maxLength={160}
                            readOnly={props.readOnly}
                        />
                    </Flex>
                </Flex>
            }
            <p></p>
            <Text>Haushaltsführung:</Text>
            <RadioGroupField
                value={daten.HAUSF_U}
                onChange={handleChange}
                name="HAUSF_U"
                direction="row">
                {['selbst/Partner', 'Pflegedienst'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.HAUSF_U !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.HAUSF_U}
                onChange={handleChange}
                name="HAUSF_U"
                direction="row">
                {['Unterstützung'].map((item, i) => <Radio key={`RG_${i + 2}`} value={i + 2} disabled={daten.HAUSF_U !== (i + 2) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            {
                daten.HAUSF_U === 2 &&
                <TextField
                    name="HAUSF_U_SONST"
                    label="durch:"
                    defaultValue={daten.HAUSF_U_SONST}
                    width="100%"
                    onChange={handleChange}
                    direction="row"
                    alignItems="center"
                    maxLength={30}
                    readOnly={props.readOnly}
                />
            }
            <p></p>
            <h5>Wohnsituation</h5>
            <RadioGroupField
                value={daten.WOHNS}
                onChange={handleChange}
                descriptiveText=""
                alignItems="center"
                name="WOHNS"
                direction="row">
                {['Mietwohnung', 'Eigentumswohnung'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.WOHNS !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.WOHNS}
                onChange={handleChange}
                descriptiveText=""
                alignItems="center"
                name="WOHNS"
                direction="row">
                {['eigenes Haus', 'Sonstige'].map((item, i) => <Radio key={`RG_${i + 2}`} value={i + 2} disabled={daten.WOHNS !== (i + 2) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            {
                daten.WOHNS === 3 &&
                <TextField
                    label=""
                    name="WOHNS_SONST"
                    defaultValue={daten.WOHNS_SONST}
                    width="100%"
                    onChange={handleChange}
                    maxLength={30}
                    readOnly={props.readOnly}
                />
            }
            <p></p>
            <h5>Bauliche Besonderheiten</h5>
            <RadioGroupField
                value={daten.HAUSB}
                onChange={handleChange}
                descriptiveText=""
                name="HAUSB"
                direction="row">
                {['keine', 'Treppen'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.HAUSB !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            {
                daten.HAUSB === 1 && <>
                    <TextField
                        name="HAUSB_TREPPEN"
                        minWidth="10%"
                        defaultValue={daten.HAUSB_TREPPEN}
                        hasError={props.hasError.HAUSB_TREPPEN}
                        errorMessage="Der Wert muß zwischen 0 und 100 liegen."
                        onChange={(e) => handleInteger(e, handleChange, 0, 100, props.hasError, props.setHasError)}
                        onBlur={(e) => handleIntegerBlur(e, 0, 100, props.hasError, props.setHasError)}
                        direction="row"
                        readOnly={props.readOnly}
                        outerEndComponent={<Button>Stufen</Button>}
                    />
                </>
            }
            <RadioGroupField
                value={daten.HAUSB}
                onChange={handleChange}
                descriptiveText=""
                name="HAUSB"
                direction="row">
                {['barrierefreie Ausstattung', 'sonstige Besonderheiten:'].map((item, i) => <Radio key={`RG_${i + 2}`} value={i + 2} disabled={daten.HAUSB !== (i + 2) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            {
                daten.HAUSB === 3 && <>
                    <TextField
                        name="HAUSB_SONST"
                        minWidth="30%"
                        defaultValue={daten.HAUSB_SONST}
                        onChange={handleChange}
                        direction="row"
                        maxLength={50}
                        readOnly={props.readOnly}
                    />
                </>
            }
            <p></p>
            <h5>Vorhandene Hilfsmittel</h5>
            <Flex
                direction="row"
            >
                <CheckboxField
                    name="HIMI_KOMPRESSIONSSTRUEMPFE"
                    value={daten.HIMI_KOMPRESSIONSSTRUEMPFE === 1 ? "off" : "on"}
                    checked={daten.HIMI_KOMPRESSIONSSTRUEMPFE === 1}
                    onChange={handleCheck}
                    label="Kompressionsstrümpfe"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="HIMI_BANDAGEN"
                    value={daten.HIMI_BANDAGEN === 1 ? "off" : "on"}
                    checked={daten.HIMI_BANDAGEN === 1}
                    onChange={handleCheck}
                    label="Bandagen"
                    disabled={props.readOnly}
                />
            </Flex>
            <Flex
                direction="row"
            >
                <CheckboxField
                    name="HIMI_KRUECKEN"
                    value={daten.HIMI_KRUECKEN === 1 ? "off" : "on"}
                    checked={daten.HIMI_KRUECKEN === 1}
                    onChange={handleCheck}
                    label="Gehstützen"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="HIMI_ROLLATOR"
                    value={daten.HIMI_ROLLATOR === 1 ? "off" : "on"}
                    checked={daten.HIMI_ROLLATOR === 1}
                    onChange={handleCheck}
                    label="Rollator"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="HIMI_ROLLSTUHL"
                    value={daten.HIMI_ROLLSTUHL === 1 ? "off" : "on"}
                    checked={daten.HIMI_ROLLSTUHL === 1}
                    onChange={handleCheck}
                    label="Rollstuhl"
                    disabled={props.readOnly}
                />
            </Flex>
            <Flex
                direction="row"
            >

                <CheckboxField
                    name="HIMI_HOERGERAET"
                    value={daten.HIMI_HOERGERAET === 1 ? "off" : "on"}
                    checked={daten.HIMI_HOERGERAET === 1}
                    onChange={handleCheck}
                    label="Hörgerät"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="HIMI_SONST_YN"
                    value={daten.HIMI_SONST_YN === 1 ? "off" : "on"}
                    checked={daten.HIMI_SONST_YN === 1}
                    onChange={handleCheck}
                    label="Sonstige:"
                    disabled={props.readOnly}
                />
                {daten.HIMI_SONST_YN === 1 &&
                    <TextField
                        name="HIMI_SONST"
                        minWidth="40%"
                        defaultValue={daten.HIMI_SONST}
                        onChange={handleChange}
                        direction="row"
                        maxLength={256}
                        readOnly={props.readOnly}
                    />
                }
            </Flex>
            <p></p>
            <h5>Soziale Belastungsfaktoren</h5>
            <Flex
                direction="row"
            >
                <CheckboxField
                    name="SOZB_FAM"
                    value={daten.SOZB_FAM === 1 ? "off" : "on"}
                    checked={daten.SOZB_FAM === 1}
                    onChange={handleCheck}
                    label="familiär"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="SOZB_BER"
                    value={daten.SOZB_BER === 1 ? "off" : "on"}
                    checked={daten.SOZB_BER === 1}
                    onChange={handleCheck}
                    label="beruflich"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="SOZB_FIN"
                    value={daten.SOZB_FIN === 1 ? "off" : "on"}
                    checked={daten.SOZB_FIN === 1}
                    onChange={handleCheck}
                    label="finanziell"
                    disabled={props.readOnly}
                />
            </Flex>
            <CheckboxField
                name="SOZB_SPR"
                value={daten.SOZB_SPR === 1 ? "off" : "on"}
                checked={daten.SOZB_SPR === 1}
                onChange={handleCheck}
                label="Sprachprobleme"
                disabled={props.readOnly}
            />
            <CheckboxField
                name="SOZB_LES"
                value={daten.SOZB_LES === 1 ? "off" : "on"}
                checked={daten.SOZB_LES === 1}
                onChange={handleCheck}
                label="Lese- und/oder Schreibprobleme"
                disabled={props.readOnly}
            />
            <Flex
                direction="row"
            >
                <CheckboxField
                    name="SOZB_SONST"
                    value={daten.SOZB_SONST === 1 ? "off" : "on"}
                    checked={daten.SOZB_SONST === 1}
                    onChange={handleCheck}
                    label="Sonstige: "
                    disabled={props.readOnly}
                />
                {daten.SOZB_SONST === 1 &&
                    <TextField
                        name="SOZB_SONST_TXT"
                        width="100%"
                        defaultValue={daten.SOZB_SONST_TXT}
                        onChange={handleChange}
                        maxLength={50}
                        readOnly={props.readOnly}
                    />
                }
            </Flex>
            <p></p>
            <h3>Freizeitaktivitäten</h3>
            <TextField
                label={<b>Hobbies</b>}
                descriptiveText="Geben Sie bitte die ausgeübten Hobbies mit Komma getrennt an."
                defaultValue={daten.HOBBY}
                name="HOBBY"
                onChange={handleChange}
                maxLength={160}
                readOnly={props.readOnly}
            />
            <p></p>
            <TextField
                label={<b>Ehrenämter/Vereine</b>}
                descriptiveText="Geben Sie bitte die Ehrenämter / Vereine mit Komma getrennt an."
                defaultValue={daten.VEREIN}
                name="VEREIN"
                onChange={handleChange}
                maxLength={160}
                readOnly={props.readOnly}
            />
            <p></p>
            <TextField
                label={<b>Sport</b>}
                descriptiveText="Geben Sie bitte die ausgeübten Sportarten mit Komma getrennt an."
                defaultValue={daten.SPORT}
                name="SPORT"
                onChange={handleChange}
                maxLength={160}
                readOnly={props.readOnly}
            />
            <p></p>
            <h5>Wie beurteilen Sie Ihr Sport- und Bewegungsverhalten?</h5>
            <RadioGroupField
                value={daten.SPORTVERHALTEN}
                onChange={handleChange}
                descriptiveText=""
                name="SPORTVERHALTEN"
                direction="row">
                {['sehr aktiv', 'aktiv', 'weniger aktiv', 'Ich mache keinen Sport'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.SPORTVERHALTEN !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <p></p>
            <h5>Führerschein</h5>
            <Flex
                direction="row"
            >
                <CheckboxField
                    name="FUE_A"
                    value={daten.FUE_A === 1 ? "off" : "on"}
                    checked={daten.FUE_A === 1}
                    onChange={handleCheck}
                    label="A (Motorrad)"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="FUE_B"
                    value={daten.FUE_B === 1 ? "off" : "on"}
                    checked={daten.FUE_B === 1}
                    onChange={handleCheck}
                    label="B (PKW)"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="FUE_C"
                    value={daten.FUE_C === 1 ? "off" : "on"}
                    checked={daten.FUE_C === 1}
                    onChange={handleCheck}
                    label="C (LKW)"
                    disabled={props.readOnly}
                />
            </Flex>
            <Flex
                direction="row"
            >

                <CheckboxField
                    name="FUE_D"
                    value={daten.FUE_D === 1 ? "off" : "on"}
                    checked={daten.FUE_D === 1}
                    onChange={handleCheck}
                    label="D (BUS)"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="FUE_S"
                    value={daten.FUE_S === 1 ? "off" : "on"}
                    checked={daten.FUE_S === 1}
                    onChange={handleCheck}
                    label="andere:"
                    disabled={props.readOnly}
                />
                {daten.FUE_S === 1 &&
                    <TextField
                        name="FUE_S_TXT"
                        defaultValue={daten.FUE_S_TXT}
                        width="30%"
                        onChange={handleChange}
                        maxLength={30}
                        readOnly={props.readOnly}
                    />
                }
            </Flex>
            <CheckboxField
                name="FUE_P"
                value={daten.FUE_P === 1 ? "off" : "on"}
                checked={daten.FUE_P === 1}
                onChange={handleCheck}
                label="Personenbeförderungsschein"
                disabled={props.readOnly}
            />
            <p></p>
            <h5>Schwerbehinderung</h5>
            <CheckboxField
                name="SCHW_GDB"
                value={daten.SCHW_GDB === 1 ? "off" : "on"}
                checked={daten.SCHW_GDB === 1}
                onChange={handleCheck}
                label="Grad der Behinderung"
                direction="row"
                disabled={props.readOnly}
            />
            {
                daten.SCHW_GDB === 1 && <>
                    <Flex
                        direction="row"
                        alignItems="center"
                    >
                        <TextField
                            name="BEHINDGRAD"
                            label="GdB:"
                            minWidth="20%"
                            defaultValue={daten.BEHINDGRAD}
                            hasError={props.hasError.BEHINDGRAD}
                            errorMessage="Der Wert muß zwischen 0 und 100 liegen."
                            onChange={(e) => handleInteger(e, handleChange, 0, 100, props.hasError, props.setHasError)}
                            onBlur={(e) => handleIntegerBlur(e, 0, 100, props.hasError, props.setHasError)}
                            direction="row"
                            alignItems="center"
                            readOnly={props.readOnly}
                        />
                        <TextField
                            label="Merkzeichen:"
                            name="BEHINDERUNG"
                            minWidth="40%"
                            defaultValue={daten.BEHINDERUNG}
                            onChange={handleChange}
                            direction="row"
                            alignItems="center"
                            maxLength={10}
                            readOnly={props.readOnly}
                        />
                    </Flex>
                    <Text>befristet gültig bis:</Text>
                    <DatePicker
                        name={"BEHINDAUSWGUELTIG"}
                        value={StringToDate(daten.BEHINDAUSWGUELTIG)}
                        onChange={props.readOnly ? () => { } : (e) => handleDate({ currentTarget: { name: "BEHINDAUSWGUELTIG", value: e } })}
                        locale="de-DE"
                        format="dd.MM.y"
                    />
                </>
            }
            {
                daten.SCHW_GDB === 1 &&
                <>
                    <Flex
                        direction="row"
                    >
                        <CheckboxField
                            name="SCHW_GLE"
                            value={daten.SCHW_GLE === 1 ? "off" : "on"}
                            checked={daten.SCHW_GLE === 1}
                            onChange={handleCheck}
                            label="Gleichstellung"
                            direction="row"
                            disabled={props.readOnly}
                        />
                        <CheckboxField
                            name="SCHW_BEA"
                            value={daten.SCHW_BEA === 1 ? "off" : "on"}
                            checked={daten.SCHW_BEA === 1}
                            onChange={handleCheck}
                            label="beantragt"
                            direction="row"
                            disabled={props.readOnly}
                        />
                    </Flex>
                    <CheckboxField
                        name="SCHW_AEN"
                        value={daten.SCHW_AEN === 1 ? "off" : "on"}
                        checked={daten.SCHW_AEN === 1}
                        onChange={handleCheck}
                        label="Änderungsantrag gestellt"
                        direction="row"
                        disabled={props.readOnly}
                    />
                </>
            }
            <p></p>
            <h5>Pflegegrad</h5>
            <Flex
                direction="row"
                alignItems="center"
            >
                <YesNo name="PFL" value={daten.PFL} onChange={handleChange} readOnly={props.readOnly} />
            </Flex>
            {
                daten.PFL === 1 && <>
                    <Flex
                        direction="row"
                        alignItems="center"
                    >

                        <CheckboxField
                            name="PFL_BEA"
                            value={daten.PFL_BEA === 1 ? "off" : "on"}
                            checked={daten.PFL_BEA === 1}
                            onChange={handleCheck}
                            label="beantragt"
                            direction="row"
                            disabled={props.readOnly}
                        />
                        <Text>Pflegegrad:</Text>
                        <TextField
                            name="PFL_SONST"
                            label=""
                            width="10%"
                            defaultValue={daten.PFL_SONST}
                            hasError={props.hasError.PFL_SONST}
                            errorMessage="Der Wert muß zwischen 0 und 5 liegen."
                            onChange={(e) => handleInteger(e, handleChange, 0, 5, props.hasError, props.setHasError)}
                            onBlur={(e) => handleIntegerBlur(e, 0, 5, props.hasError, props.setHasError)}
                            direction="row"
                            readOnly={props.readOnly}
                        />
                    </Flex>
                </>
            }
            <p></p>
            <h5>Altersrente</h5>
            <p><i>Wenn Sie hier mit Ja antworten, werden die folgenden Fragen zum Beruf übersprungen.</i></p>
            <Flex
                direction="row"
                alignItems="center"
            >
                <YesNo name="RENTE" value={daten.RENTE} onChange={handleChange} readOnly={props.readOnly} />
                {daten.RENTE === 1 &&
                    <>
                        <TextField
                            label="seit"
                            name="RENTE_DAT"
                            width="20%"
                            defaultValue={daten.RENTE_DAT}
                            hasError={props.hasError.RENTE_DAT}
                            errorMessage="Innerhalb der lezten 100 Jahre!"
                            onChange={(e) => { handleSimpleDate(e, handleChange, props.hasError, props.setHasError) }}
                            onBlur={(e) => { handleSimpleDateBlur(e, props.hasError, props.setHasError) }}
                            placeholder="Jahreszahl?"
                            direction="row"
                            alignItems="center"
                            readOnly={props.readOnly}
                        />
                        <TextField
                            label="letzte berufliche Tätigkeit:"
                            name="EXBERUF"
                            defaultValue={daten.EXBERUF}
                            width="80%"
                            onChange={handleChange}
                            direction="row"
                            alignItems="center"
                            maxLength={50}
                            readOnly={props.readOnly}
                        />
                    </>
                }
            </Flex>
        </Flex>
    )
}

export default SozialAnamnese;